import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import EnginesCheckboxList from "./EngineCheckBoxList";
import ControllerCheckbox from "../../../SharedComponents/formComponents/baseFormComponents/ControllerCheckbox";
import { getFallbackMakeLogoImage } from "../../utils/carLogo/getFallbackMakeLogoImage";
import ArrowIcon from "../../assets/icons/svg/ArrowBlackSVG";
import ArrowDownIcon from "../../assets/icons/svg/ArrowDownSVG";

import { getStoreData } from "../../reduxStore/entities/userFIlterStore";

const PageTwo = ({ selectedMake, onGoBack, onConfirm }) => {
  const dispatch = useDispatch();
  const { control, watch, reset, getValues } = useForm({ defaultValues: {} });

  const { generations, enginesByGeneration, generationToModel } = useSelector(
    (state) => state.storeData
  );

  const [openGenerations, setOpenGenerations] = useState({});

  useEffect(() => {
    if (selectedMake) {
      dispatch(getStoreData(selectedMake));
    }
  }, [selectedMake, dispatch]);

  useEffect(() => {
    const defaultVals = {};
    generations.forEach((gen) => {
      defaultVals[`generation_${gen.id_car_generation}`] = false;
      defaultVals[`engine_generation_${gen.id_car_generation}`] = [];
    });
    reset(defaultVals);
  }, [generations, reset]);

  const generationCheckboxValues = watch(
    generations.map((gen) => `generation_${gen.id_car_generation}`)
  );

  const toggleOpenGeneration = (generationId) => {
    setOpenGenerations((prev) => ({
      ...prev,
      [generationId]: !prev[generationId],
    }));
  };

  const handleConfirm = () => {
    const values = getValues();

    const selectedGenerations = generations.filter(
      (gen) => values[`generation_${gen.id_car_generation}`]
    );

    const modelsMap = {};

    for (const gen of selectedGenerations) {
      const model = generationToModel[gen.id_car_generation];
      if (!model) continue;

      if (!modelsMap[model.id_car_model]) {
        modelsMap[model.id_car_model] = {
          id_car_model: model.id_car_model,
          generations: [],
        };
      }

      const selectedEngineIds =
        values[`engine_generation_${gen.id_car_generation}`] || [];

      const selectedEngines = (enginesByGeneration[gen.id_car_generation] || [])
        .filter((engine) => selectedEngineIds.includes(engine.id_car_motor))
        .map((engine) => ({
          id_car_motor: engine.id_car_motor,
          name: engine.name || engine.label,
        }));

      modelsMap[model.id_car_model].generations.push({
        id_car_generation: gen.id_car_generation,
        name: gen.name,
        engines: selectedEngines,
      });
    }

    const structuredData = {
      id_car_make: selectedMake.id_car_make,
      name: selectedMake.name,
      models: Object.values(modelsMap),
    };

    onConfirm(structuredData);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>
          2/2 Izaberi model i generaciju automobila:
        </div>
        <div style={styles.buttonsContainer}>
          <button onClick={onGoBack} style={styles.backButton}>
            Nazad
          </button>
          <button onClick={handleConfirm} style={styles.confirmButton}>
            Potvrdi izbor
          </button>
        </div>
      </div>

      <div style={styles.makeContainer}>
        <img
          src={getFallbackMakeLogoImage(selectedMake.name)}
          alt={selectedMake.name}
          style={styles.makeLogo}
        />
        <p style={styles.makeName}>{selectedMake.name}</p>
      </div>

      {generations.map((gen, index) => {
        const genChecked = generationCheckboxValues?.[index];
        const isOpen = openGenerations[gen.id_car_generation];

        return (
          <div key={gen.id_car_generation} style={styles.generationWrapper}>
            <div
              style={styles.generationHeader}
              onClick={() => toggleOpenGeneration(gen.id_car_generation)}
            >
              {isOpen ? (
                <ArrowDownIcon style={styles.arrowIcon} />
              ) : (
                <ArrowIcon style={styles.arrowIcon} />
              )}
              <ControllerCheckbox
                name={`generation_${gen.id_car_generation}`}
                control={control}
                labelText={gen.name}
              />
            </div>
            {isOpen && genChecked && (
              <EnginesCheckboxList
                generationId={gen.id_car_generation}
                control={control}
                engines={enginesByGeneration[gen.id_car_generation] || []}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PageTwo;

const styles = {
  container: {
    padding: 20,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "black",
  },
  buttonsContainer: {
    display: "flex",
    gap: 10,
    marginLeft: 40,
  },
  backButton: {
    backgroundColor: "#FFFFFF",
    color: "rgba(91, 33, 182, 1)",
    borderRadius: 8,
    padding: "10px 24px",
    fontSize: 16,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
  },
  confirmButton: {
    backgroundColor: "#000000",
    color: "#F3F3F3",
    borderRadius: 8,
    padding: "10px 24px",
    fontSize: 16,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
  },
  makeContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  makeLogo: {
    width: 80,
    height: 80,
    objectFit: "contain",
    marginRight: 10,
  },
  makeName: {
    fontSize: 20,
    fontWeight: "bold",
    margin: 0,
  },
  generationWrapper: {
    marginBottom: 10,
  },
  generationHeader: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  arrowIcon: {
    width: 16,
    height: 16,
    marginRight: 8,
  },
};
